var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useRef, useState } from 'react';
import { FieldImage, Loading } from '../elements';
import { api } from '../helpers/Api';
import cxs from 'cxs/component';
import { inject } from 'mobx-react';
import { T } from '../helpers/i18n';
export var StretchImages = inject('store')(function (props) {
    var images = props.images, onDragged = props.onDragged;
    var dragItem = useRef();
    var dragOverItem = useRef();
    var _a = useState(images), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var dragStart = function (e) {
        dragItem.current = e.target.id;
    };
    var dragEnter = function (e) {
        dragOverItem.current = e.currentTarget.id;
    };
    var drop = function () {
        var copyListItems = __spreadArray([], data, true);
        // @ts-ignore
        var dragItemContent = copyListItems[dragItem.current];
        copyListItems.splice(dragItem.current, 1);
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;
        if (!onDragged)
            throw new Error('prop onDragged not exits');
        if (typeof onDragged !== 'function')
            throw new Error('prop onDragged not is function');
        // elimino vacíos desde atrás hasta encontrar uno con imagen
        var result = [];
        for (var i = copyListItems.length; i >= 0; i--) {
            if (copyListItems[i - 1].url) {
                var temp = copyListItems.slice(0, i);
                result.push.apply(result, temp);
                break;
            }
        }
        // propago
        onDragged(result);
        // actualizo vista
        setData(result);
    };
    /* upload one image           */
    var upLoadImage = function (value, name, column) {
        var formData = new FormData();
        if (value) {
            formData.append('image', value);
        }
        formData.append('type', 'stretch');
        formData.append('stretch_id', String(props.stretch_id));
        formData.append('folder', "/service/".concat(props.stretch_id));
        formData.append('name', column || name);
        return api.post('images/stretch', formData);
    };
    var handleChange = function (name, value, column) { return __awaiter(void 0, void 0, void 0, function () {
        var index_1, splitted_1, newImages, availableIndexes, iLibre, numberToFind, valueIndex, _i, availableIndexes_1, availableIndex, result, temp, allImages;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    if (!value) {
                        index_1 = data.findIndex(function (image) { return image.name === name; });
                        splitted_1 = name.split('image');
                        props.store.UI.newWarning('eliminando imagen ' + splitted_1[1]);
                        upLoadImage(null, name, column).then(function (result) {
                            console.log('result: ', result);
                            if (!result || result.result !== 'ok') {
                                props.store.UI.newError(T('error'));
                            }
                            setLoading(false);
                            var temp = __spreadArray([], data, true);
                            temp.splice(index_1, 1);
                            props.store.UI.newWarning('eliminado ' + splitted_1[1]);
                            console.log('temp: ', temp);
                            setData(temp);
                        });
                        return [2 /*return*/];
                    }
                    newImages = [];
                    if (name !== 'multiple') {
                        // es sólo 1 imagen y se está cambiando
                        upLoadImage(value[0], name, column).then(function () { return setLoading(false); });
                        return [2 /*return*/];
                    }
                    availableIndexes = [];
                    iLibre = 0;
                    numberToFind = value.length;
                    while (availableIndexes.length < numberToFind) {
                        // los que tienen url vacío
                        if (((_a = data[iLibre]) === null || _a === void 0 ? void 0 : _a.url) === '') {
                            availableIndexes.push(iLibre + 1);
                        }
                        iLibre++;
                        // los que existen
                        if (!data.find(function (image) { return image.name === "image".concat(iLibre); })) {
                            availableIndexes.push(iLibre);
                        }
                    }
                    valueIndex = 0;
                    _i = 0, availableIndexes_1 = availableIndexes;
                    _b.label = 1;
                case 1:
                    if (!(_i < availableIndexes_1.length)) return [3 /*break*/, 4];
                    availableIndex = availableIndexes_1[_i];
                    return [4 /*yield*/, upLoadImage(value[valueIndex], "image".concat(availableIndex), null)
                        // console.log('result upload: ', result)
                    ];
                case 2:
                    result = _b.sent();
                    // console.log('result upload: ', result)
                    valueIndex++;
                    temp = {
                        name: "image".concat(availableIndex),
                        url: result.url
                    };
                    newImages.push(temp);
                    allImages = __spreadArray(__spreadArray([], data, true), newImages, true).sort(function (a, b) {
                        var splittedA = Number(a.name.split('image')[1]);
                        var splittedB = Number(b.name.split('image')[1]);
                        return splittedA - splittedB;
                    });
                    setData(allImages);
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
        loading && React.createElement(WrapperLoading, null),
        React.createElement(WrapperItem, { key: 'container' + 'multiple', style: { width: '100%', height: '320px', borderStyle: 'dotted', margin: '10px' } },
            React.createElement(FieldImage, { key: 'image' + 'multiple', style: {
                    width: '100%',
                    height: '310px'
                }, value: '', name: 'multiple', footer: 'puedes añadir más de una max 5MB por archivo', multiple: true, deletable: false, onChange: handleChange })),
        data.map(function (image, index) {
            return (React.createElement(WrapperItem, { key: 'container' + image.name, id: String(index), style: { width: '320px', height: '320px', borderStyle: 'dotted', margin: '10px' }, onDragStart: function (e) { return dragStart(e); }, onDragEnter: function (e) { return dragEnter(e); }, onDragEnd: drop, draggable: true },
                React.createElement(FieldImage, { key: image.name, style: {
                        width: '310px',
                        height: '310px'
                    }, name: image.name, value: image.url, footer: 'max 5MB', deletable: true, onChange: handleChange })));
        })));
});
var WrapperItem = cxs('div')({
    width: '320px',
    height: '320px',
    borderStyle: 'dotted',
    margin: '5px',
    borderRadius: '5px'
});
var WrapperLoading = cxs(Loading)({
    position: 'absolute'
});



//////////////////
// WEBPACK FOOTER
// ./src/components/StretchImages.tsx
// module id = 1518
// module chunks = 0